module.exports = __webpack_public_path__ + "img/13.a323c251.jpg";